/* Componente responsável pelo cadastro de um novo tópico no fórum. Ele renderiza um formulário com campos para o assunto e o comentário do tópico, além de gerenciar o estado desses campos e enviar os dados para o backend ao submeter o formulário. O componente também exibe mensagens de sucesso ou erro com base na resposta do servidor.
Se o componente receber o id, e demais dados como prop faremos a edição do tópico, caso contrário faremos a criação de um novo tópico.

*/
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Botao from '../Botao';
import Mensagem from '../Mensagem';
import CampoTexto from '../CampoTexto';
import './CadastroForum.css';
import { useAuth } from '../../contextos/AuthContext'; // Importa o hook useAuth do contexto de autenticação para acessar o estado do usuário logado e funções relacionadas à autenticação

const CadastroForum = ( {exibir, aoFechar, id, topico, texto, idResposta} ) => {
    const navigate = useNavigate(); // Hook para navegação programática 
    const [assunto, setAssunto] = useState(topico || ''); // Estado para armazenar o assunto do tópico. Iniciado como null para permitir que o campo seja editável apenas quando houver um valor definido.
    const [comentario, setComentario] = useState(texto || ''); // Estado para armazenar o comentário do tópico. Se a prop texto for fornecida, o estado será inicializado com esse valor, caso contrário, será uma string vazia.
    const [mensagem, setMensagem] = useState({ texto: '', tipo: '' }); // Estado para armazenar mensagens de feedback ao usuário
    const [carregando, setCarregando] = useState(false); // Estado para controlar o carregamento durante a requisição

    const { token } = useAuth(); // Hook para acessar o contexto de autenticação e obter o token do usuário logado


    // Atualiza os dois estados sempre que as props mudarem
    useEffect(() => {
        setAssunto(topico || ''); // Atualiza o estado do assunto com o valor da prop topico ou null se não houver valor
        setComentario(texto || ''); // Atualiza o estado do comentário com o valor da prop texto ou null se não houver valor
    }, [topico, texto]); // ← executa sempre que topico ou texto mudar


    const publicarConteudo = async ( evento) => {
        // Essencial: Impede o recarregamento da página e a "sujeira" na URL
        evento.preventDefault(); 
        
        setCarregando(true); // Trava o botão de envio durante a requisição
        setMensagem({ texto: '', tipo: '' }); // Limpa mensagens anteriores

        
        //  Criar o "envelope" FormData. Monta o objeto com os estados.
        const formData = new FormData();
        formData.append('id', id); // Adiciona o ID do tópico ao FormData, mesmo que seja null. O backend deve lidar com isso.
        formData.append('assunto', assunto);
        formData.append('comentario', comentario);
        formData.append('idResposta', idResposta); // Adiciona o ID da resposta ao FormData, mesmo que seja null. O backend deve lidar com isso.

        console.log('FormData:', {
            id: id,
            assunto: assunto,
            comentario: comentario,
            idResposta: idResposta
        });


        try {
            // 3. Usa a variável de ambiente que agora está funcionando
            // O React substitui isso em tempo de execução. A variável baseUrl conterá a URL da API definida no arquivo .env
            

            const endpoint = !id ? '/forum-new' : '/forum-update'; // Define o endpoint com base no estado do id. Se id for null, significa que estamos criando um novo tópico, caso contrário, estamos editando um tópico existente.
            const url =  `${process.env.REACT_APP_API_URL}${endpoint}`;

            // Configura os cabeçalhos da requisição, incluindo o token de autenticação se estiver disponível
            const headers = {
                // 'Content-Type': 'multipart/form-data', // Importante: Não definimos o 'Content-Type' manualmente para FormData. O navegador fará isso automaticamente, incluindo os limites necessários para multipart/form-data.
            };    


            // Se houver um token (usuário logado editando), adicionamos ao cabeçalho
            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            }
            
            // Envia os dados do usuário para a API
            const resposta = await fetch(url, {
                method: 'POST',
                headers,
                body: formData/* Enviamos o FormData direto, sem JSON.stringify
                                IMPORTANTE: Não definimos o 'Content-Type' manualmente aqui.  
                                O navegador fará isso automaticamente para multipart/form-data */
                
            });

            if (resposta.ok) {
                const dadosRetorno = await resposta.json();
                console.log(dadosRetorno);
                if (dadosRetorno.status === 'sucesso') {
                    setMensagem({ texto: dadosRetorno.mensagem, tipo: dadosRetorno.status });

                    navigate('/resultado', { 
                          state: { 
                            status: dadosRetorno.status,
                            mensagem: dadosRetorno.mensagem
                          }
                        });

                    // Limpa os campos após o envio
                    setAssunto('');
                    setComentario('');
                    setCarregando(false); // Destrava o botão de envio após o processamento da requisição
                    return;


                } else {
                    setMensagem({ texto: dadosRetorno.mensagem, tipo: dadosRetorno.status });
                    setCarregando(false); // Destrava o botão de envio após o processamento da requisição
                    return;
                }
            } else {
                // Aqui o PHP enviou um erro proposital (ex: 400 Bad Request)
                const erroRetorno = await resposta.json();
                setMensagem({
                    texto: erroRetorno.mensagem || "Erro ao processar a solicitação.",
                    tipo: "erro"
                });
                setCarregando(false); // Destrava o botão de envio após o processamento da requisição
            }
        } catch (erro) {
            console.error('Erro ao enviar os dados:', erro);
            setMensagem({ texto: 'Erro ao enviar os dados. Por favor, tente novamente.', tipo: 'erro' });
            setCarregando(false); // Destrava o botão de envio após o processamento da requisição
        }       

    }


    if (!exibir) return null; // Não renderiza a tela de login se o estado for falso

    return (
        <div className="modal-overlay-forum">
            {/* O stopPropagation impede que o modal feche ao clicar dentro da caixa branca */}
                <div className="modal-conteudo-forum  bg-white p-md-5 rounded-0 text-black p-4" 
                onClick={e => e.stopPropagation()}>

                    {/* Botão de fechar o modal */}
                    <button className="btn-fechar bg-dark" onClick={aoFechar}>&times;</button>   

                    <h2>Nova Mensagem - Fórum de Estudos </h2>

                        <form onSubmit={publicarConteudo} className="row g-3 mt-3">

                            <CampoTexto
                                label="Assunto"
                                labelClass="form-label fs-5"
                                className="form-control form-control-lg fs-3"
                                wrapperClass="col-12"
                                tipo="text"
                                placeholder="Digite o título do assunto do tópico"
                                obrigatorio={true}
                                editavel={topico ? false : true}  /* O campo só é editável se o tópico passado  não estiver null */
                                tamanhoMaximo={150}
                                id="assunto"
                                nome="assunto"
                                valor={assunto}  
                                aoDigitado={ (valor) => setAssunto(valor)}
                            />


                            {/* Comentário — textarea para mais espaço */}

                            <div className="col-12 mb-3">
                                <label className="form-label fs-5">Comentário</label>
                                <textarea
                                    className="form-control form-control-lg fs-3"
                                    placeholder="Digite o comentário do tópico"
                                    maxLength={3000}
                                    rows={8}          /* ← altura do campo em linhas */
                                    required
                                    id="comentario"
                                    name="comentario"
                                    value={comentario}
                                    onChange={(e) => setComentario(e.target.value)}
                                />
                            {/* Contador de caracteres */}
                            <small className="text-muted">{comentario.length}/3000 caracteres</small>    
                            </div>
                            
                            <Mensagem mensagem={mensagem.texto} tipo={mensagem.tipo} />

                            <div className="col-12 mt-3">
                                <Botao
                                    className="btn btn-primary btn-lg"
                                    tipo="submit"  disabled={carregando}>
                                    {carregando ? 'Enviando...' : 'Publicar'}
                                </Botao>
                            </div>

                        </form>
                </div>
        </div>
    );


}

export default CadastroForum;
